export default __webpack_public_path__ + "static/scholar_logo-ebcd9c3236138b09f3e019de80faa513.png";